/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import { getFormattedDate } from '../../../../utils/v2';
import { StyledTypography } from './FormattedDateTime.styles';

export const FormattedDateTime = (props, ignoreZone = false, zone) => {
  const value = props?.cell?.value || props;
  const format = props?.column?.format || 'MM/dd/yyyy, hh:mm a';

  if (!value) {
    return null;
  }
  const formattedDate = getFormattedDate(value, {
    format,
    ignoreZone,
    zone,
  });

  return <StyledTypography>{formattedDate}</StyledTypography>;
};

FormattedDateTime.propTypes = {
  cell: PropTypes.object,
  column: PropTypes.object,
};
